// extracted by mini-css-extract-plugin
export var footer = "_n0-5";
export var fulfillmentInput = "_n0-0";
export var shipDateInput = "_n0-1";
export var shipmentModal = "_n0-2";
export var shipmentModalContent = "_n0-3";
export var tableContainer = "_n0-4";